import { Tag, Badge, Stack, CircularProgress, Text } from '@/components/lib'

export default function BMITag ({ bmi, asCircular }) {
  if (!bmi) return null

  let bmiLabel = 'Underweight'
  let bmiColour = 'blue'
  if (bmi > 18 && bmi < 25) {
    bmiColour = 'green'
    bmiLabel = 'Healthy'
  }
  if (bmi >= 25 && bmi < 30) {
    bmiColour = 'yellow'
    bmiLabel = 'Overweight'
  }
  if (bmi >= 30) {
    bmiColour = 'red'
    bmiLabel = 'Obese'
  }

  let bmiValue = (bmi * 100) / 40 // We make 40 the max on the circular bar
  if (bmiValue > 100) bmiValue = 100

  if (asCircular) {
    return (
      <Stack direction='column' alignItems='center' justifyContent='center'>
        <CircularProgress value={bmiValue} size='xl' />
        <Badge>
          <Text fontFamily='monospace' color='fg.muted'>{bmi.toFixed(2)}</Text>
          {bmiLabel}
        </Badge>
      </Stack>
    )
  }
  return (
    <Tag colorPalette={bmiColour}>{bmi?.toFixed(2) || 'Unknown BMI'} ({bmiLabel})</Tag>
  )
}
